import {
    PenTool,
    Code2,
    RefreshCw,
    Smartphone,
    LayoutTemplate,
} from "lucide-react";
import { Reveal, ChapterHeading } from "./Reveal";

const SERVICES = [
    {
        id: "custom-design",
        icon: PenTool,
        title: "Custom Website Design",
        description:
            "A design built around your brand and your customers, never a template. You get a site that looks like no one else's.",
    },
    {
        id: "development",
        icon: Code2,
        title: "Website Development",
        description:
            "A clean build that loads fast and is easy to maintain long after launch.",
    },
    {
        id: "redesigns",
        icon: RefreshCw,
        title: "Website Redesigns",
        description:
            "Turn an outdated site into a modern one that finally shows the quality of your business, without losing what already works.",
    },
    {
        id: "responsive",
        icon: Smartphone,
        title: "Mobile Responsive Design",
        description:
            "Every page is designed to work beautifully on phones, tablets, and computers.",
    },
    {
        id: "landing-pages",
        icon: LayoutTemplate,
        title: "Landing Pages",
        description:
            "A single page with one job: getting visitors to say yes. Perfect for a launch, a special offer, or a campaign you're running.",
    },
];

const Services = () => (
    <section
        id="services"
        data-testid="services-section"
        className="bg-mist py-20 sm:py-28 lg:py-32"
    >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <ChapterHeading
                testId="services-heading"
                chapter="02"
                eyebrow="Services"
                title="Everything your website needs, handled by one person."
                description="From first sketch to launch day and beyond: design, development, and ongoing care under one roof."
            />
            <div className="mt-14 grid grid-cols-1 gap-6 sm:mt-16 md:grid-cols-2 lg:grid-cols-3">
                {SERVICES.map((service, i) => {
                    const Icon = service.icon;
                    return (
                        <Reveal key={service.id} delay={(i % 3) * 0.08}>
                            <div
                                data-testid={`service-card-${service.id}`}
                                className="group h-full rounded-2xl border border-slate-200 bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-brand/30 hover:shadow-[0_24px_48px_-28px_rgba(37,99,235,0.25)] sm:p-8"
                            >
                                <div className="flex items-center justify-between">
                                    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-ice text-brand-dark transition-colors duration-300 group-hover:bg-brand group-hover:text-white">
                                        <Icon className="h-5 w-5" />
                                    </span>
                                    <span className="font-mono text-xs text-slate-300 transition-colors duration-300 group-hover:text-brand/60">
                                        0{i + 1}
                                    </span>
                                </div>
                                <h3 className="mt-6 text-lg font-semibold tracking-tight text-ink">
                                    {service.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                                    {service.description}
                                </p>
                            </div>
                        </Reveal>
                    );
                })}
            </div>
        </div>
    </section>
);

export default Services;
